type FormatDateStyle = 'short' | 'long' | 'datetime';

const styles: Record<FormatDateStyle, Intl.DateTimeFormatOptions> = {
  short: {day: '2-digit', month: '2-digit', year: 'numeric'},
  long: {day: 'numeric', month: 'long', year: 'numeric'},
  datetime: {day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit'},
};

export function formatDate(
  date: Date | string,
  style: FormatDateStyle = 'long',
): string {
  const d = typeof date === 'string' ? new Date(date) : date;

  return d.toLocaleDateString('pt-BR', styles[style]);
}
